import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

type StyledDividerProps = {
  $vertical: boolean;
  $margin: number;
  $color?: string;
};

const StyledDivider = styled.div<StyledDividerProps>`
  background-color: ${({ $color }) => $color ?? theme.colors.purple_2};
  flex-shrink: 0;
  width: ${({ $vertical }) => ($vertical ? "1px" : "100%")};
  height: ${({ $vertical }) => ($vertical ? "auto" : "1px")};
  margin: ${({ $vertical, $margin }) =>
    $vertical ? `0px ${$margin}px` : `${$margin}px 0px`};
`;

export { StyledDivider };
